import firebase from 'firebase';
import 'firebase/firestore';

// Firebase Config
const firebaseConfig = {
  apiKey: "AIzaSyBrlJg-cEd0-DxjVh_lt5jve5rbHiIBLEI",
  authDomain: "calculadoraimpuestos-158e5.firebaseapp.com",
  databaseURL: "https://calculadoraimpuestos-158e5.firebaseio.com",
  projectId: "calculadoraimpuestos-158e5",
  storageBucket: "calculadoraimpuestos-158e5.appspot.com",
  messagingSenderId: "1045831128696",
  appId: "1:1045831128696:web:7127ef3facdcd58c877f8d",
  measurementId: "G-GJJ5N1KFV3"
}
// Exports
const Firebase = firebase.initializeApp(firebaseConfig);
const Database = firebase.firestore();
const Storage = firebase.storage();

export { Firebase, Database, Storage };